module.exports = __webpack_public_path__ + "media/logo.01802610.mp4";